var map = {
	"./logo-ALL.svg": 1434,
	"./logo-CB.svg": 6410,
	"./logo-CN.svg": 8414,
	"./logo-DG-1.svg": 1832,
	"./logo-DG-2.svg": 6219,
	"./logo-DG.svg": 6746,
	"./logo-GB.svg": 1934,
	"./logo-GG.svg": 6819,
	"./logo-GJ.svg": 4422,
	"./logo-GN.svg": 9434,
	"./logo-GW.svg": 2147,
	"./logo-IC.svg": 4045,
	"./logo-JB.svg": 7073,
	"./logo-JJ.svg": 4809,
	"./logo-JN.svg": 1349,
	"./logo-US.svg": 3785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7883;